export class ReportFilter {
    user:   string;
    code:   string;
    dealer: number;
}